import {ContentContext} from "../../../../utils/contexts";

const { Visibility, StarBorder } = window.MaterialIcons;
const { ListItemText, ListItemIcon, Button, Popover, MenuList, MenuItem, withStyles } = window.Material;
import { filters } from "../../../../constants";

const styles = () => ({
  filterOn: {
    background: '#ff9a00 !important',
    padding: '0.5rem',
    minWidth: '0',
  },
  filterOff: {
    padding: '0.5rem',
    minWidth: '0',
  },
});

class Filters extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  handleDropDownClick = event => {
    this.setState({ anchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState(() => ({ anchor: null }));
  };

  onFilterClick = name => {
    const { fetchChildrenByFilter, fetchContent, fetchTreeChildren, setProperty } = this.context;

    setProperty("filter", name || null);

    if (!name) {
      fetchContent();
      fetchTreeChildren();
    } else {
      fetchChildrenByFilter(name);
    }

    this.closeMenu();
  };

  getIcon = name => {
    switch (name) {
      case 'editingMe': {
        return 'edit';
      }
      case 'editingOthers': {
        return 'user-edit';
      }
      case 'recentlyAdded':
      case 'recentlyModified': {
        return 'clock';
      }
      case 'favourites': {
        return 'star';
      }
      default: {
        break;
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { filter, loadingContent } = this.context;

    const filterSelected = filter && filter !== 'favourites';
    const favouritesSelected = filter && filter === 'favourites';

    return (
      <div>
        <Button
          variant="outlined"
          disabled={loadingContent}
          onClick={filterSelected ? () => this.onFilterClick(null) : this.handleDropDownClick}
          classes={{
            root: filterSelected ? classes.filterOn : classes.filterOff,
          }}
          id="filtersDropdownBtn"
        >
          <Visibility color={filterSelected ? 'secondary' : 'inherit'} fontSize="small" />
        </Button>
        <Popover
          open={this.state.anchor !== null}
          anchorEl={this.state.anchor}
          onClose={this.closeMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuList>
            {filters
              .filter(item => item !== 'favourites')
              .map(item => (
                <MenuItem key={item} onClick={() => this.onFilterClick(item)} selected={filter === item} id={item}>
                  <ListItemIcon>
                    <i className={`fas fa-${this.getIcon(item)}`} />
                  </ListItemIcon>
                  <ListItemText
                    primary={window.Alfresco.messages.global[`edocat.document-library.filters.${item}.title`]}
                  />
                </MenuItem>
              ))}
          </MenuList>
        </Popover>
        <Button
          variant="outlined"
          onClick={() => this.onFilterClick(favouritesSelected ? null : 'favourites')}
          classes={{ root: favouritesSelected ? classes.filterOn : classes.filterOff }}
          id="favouritesBtn"
          disabled={loadingContent}
        >
          <StarBorder color={favouritesSelected ? 'secondary' : 'inherit'} fontSize="small" />
        </Button>
      </div>
    );
  }
}

Filters.contextType = ContentContext;

export default withStyles(styles)(Filters);
